import { _QueryResources } from 'datx-jsonapi-react';

import { Article } from '@/resources/Article';

export const queryArticlesByLectureId = (lectureId: string): _QueryResources<Article> => [
  Article,
  {
    filter: {
      lecture_id: lectureId,
    },
  },
];
